import { Component, OnInit } from '@angular/core';
import { baseUrl } from 'src/environments/environment';
import { AllSpecialitiesData } from 'src/app/_models/allSpecialities.model';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';
import { ActivatedRoute } from '@angular/router';
import { showNotification } from 'src/app/helpers/show-toast';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
// import {SearchFilterPipe as query }from '../../../pipe/search-speciality.pipe'
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PushNotificationModalComponent } from '../components/push-notification-modal/push-notification-modal.component';
import { ReportModalComponent } from '../components/report-modal/report-modal.component';
import { sortTable } from 'src/app/helpers/sort-table';

@Component({
  selector: 'app-specialties',
  templateUrl: './specialties.component.html',
  styleUrls: ['./specialties.component.scss'],
})
export class SpecialtiesComponent implements OnInit {
  pageTitle: string = 'Specialities';
  placeholder: string = 'Search by speciality name …';
  allSpecialitiesArray: AllSpecialitiesData[] = [];
  filteredAllSpecialitiesArray: AllSpecialitiesData[] = [];
  query: '';
  invertSort: boolean = false;
  theadArray = [
    'Speciality En Name',
    'Speciality AR Name',
    'Speciality Rank',
    'Speciality Active',
    'Speciality Anonymous',
    'Speciality Actions'
  ];

  modalRef: BsModalRef;

  constructor(
    private _AllSpecialitiesApi: AllSpecialitiesApi,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getAllSpecialities();
  }

  getAllSpecialities() {
    this._AllSpecialitiesApi.getAllSpecialties().subscribe((res) => {
      res.data.doctorSpecilaities.map((specialties) => {
        specialties.featuredImage = `${specialties.featuredImage}`;
        this.allSpecialitiesArray.push(specialties);
      });

      this.filteredAllSpecialitiesArray = [...this.allSpecialitiesArray];
    });
  }

onSearchSpeciality(searchString: string): void {
  if (searchString.trim() === '') {
    // If search string is empty, restore the full list without making an API call
    this.filteredAllSpecialitiesArray = [...this.allSpecialitiesArray];
  } else {
    // If search string is not empty, call the API to search by name
    this._AllSpecialitiesApi.searchByName(searchString).subscribe((response) => {
      this.filteredAllSpecialitiesArray = response['data']['doctorSpecilaities'];
    });
  }
}


onSearchInputKeyup(searchString: string): void {
  if (searchString.trim() === '') {
    // If search input is empty, restore the full list
    this.filteredAllSpecialitiesArray = [...this.allSpecialitiesArray];
  }
}


  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredAllSpecialitiesArray = sortTable(
      this.filteredAllSpecialitiesArray,
      'name',
      this.invertSort
    );
  }

  onSpecialityActiveChange(event, speciality) {
    speciality.isActive = event.target.checked;

    this._AllSpecialitiesApi
      .updateSpecialty(speciality)
      .subscribe((response) => {
        showNotification(
          'success',
          `${response.data.name} speciality has been ${response.data.isActive ? 'Activated' : 'Deactivated'
          }`,
          this.toastr
        );
      });
  }

  onSpecialityAnonymousChange(event, speciality) {
    speciality.isAnonymous = event.target.checked;

    this._AllSpecialitiesApi
      .updateSpecialty(speciality)
      .subscribe((response) => {

        showNotification(
          'success',
          `${response.data.name} speciality is ${response.data.isAnonymous ? 'Anonymous' : 'Un Anonymous'
          }`,
          this.toastr
        );
      });
  }

  onCopyHandler(event, val: HTMLInputElement, pop) {
    event.stopPropagation();

    val.readOnly = true;
    val.select();
    val.setSelectionRange(0, 99999);
    document.execCommand('copy');

    setTimeout(() => {
      pop.hide();
    }, 1500);
  }

  onPushNotification(event, speciality): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        speciality
      }
    };

    this.modalRef = this.modalService.show(PushNotificationModalComponent, initialState);
  }

  onGetReport(speciality): void {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        specialityId: speciality.id,
        specialityName: speciality.name,
        specialityArName: speciality.arName
      }
    };

    this.modalRef = this.modalService.show(ReportModalComponent, initialState);
  }

  ExportTOExcel(): void {
    const data = [];
    this.filteredAllSpecialitiesArray.map(
      (specialty: AllSpecialitiesData, index) =>
        data.push({
          id: specialty.id,
          'English Name': specialty.name,
          'Arabic Name': specialty.arName,
          active: specialty.isActive,
          anonymous: specialty.isAnonymous,
          Rank: specialty.rank,
          imagePath: specialty.imagePath,
          featureImagePath: specialty.featuredImage,
          link: specialty.link,
        })
    );
    const ws = XLSX.utils.json_to_sheet(data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');



    /* save to file */
    XLSX.writeFile(wb, `Specialities - ${Date.now()}.xlsx`);
  }
}
